export default "/cover.png"